import { useContext } from 'react'

import { StoryContext } from './story-context'

export const useShouldActionActivatedInStory = () => {
    const storyContext = useContext(StoryContext)

    // oxlint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return storyContext.parameters?.isActionActivated
}
